// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_v-1";
export var movingGradient = "_v-4";
export var movingGradientBlock = "_v-2";
export var skeleton = "_v-0";
export var skeletonText = "_v-3";